// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2vw6e","text":"SelectPayment_text__1CbVp","title":"SelectPayment_title__1mwQ9","btn":"SelectPayment_btn__1ejJg"};